export const layoutPadding = 'mx-auto px-8 lg:px-10 sm:px-6'
export const inputFocus =
  'focus-within:[#B6BBC0] text-mountain-bluebird focus-within:ring-0 outline-0 outline-none focus:border-creamed-cron focus:ring-0'
export const inputError =
  'ring-red-400 ring-1 ring-offset-0 outline-red-400 outline-1'
export const inputDisabled = 'disabled:bg-grey-10 disabled:cursor-not-allowed'
export const inputOutlined = 'outline-[0.7px] outline-grey-50'
export const inputBase =
  'border border-[#B6BBC0] bg-white h-11 sm:h-14 w-full rounded-md hover:bg-gray-50 hover:border-creamed-corn transition-colors'
export const textareaBase =
  'border border-[#B6BBC0] bg-white  w-full rounded-md hover:bg-gray-50 hover:border-creamed-corn transition-colors'
export const textErrorColor = 'text-red-400'
